export const kpiData = [
  { id: 'visitors', label: "Bugünkü Ziyaretçi", value: 1284, change: 12.4, icon: 'ri-user-line', color: '#D4AF37', trend: [40,55,47,60,75,65,80,90,85,95] },
  { id: 'unique', label: "Toplam Tekil Ziyaretçi", value: 8742, change: 8.2, icon: 'ri-group-line', color: '#F4C2C2', trend: [60,65,70,68,80,78,85,90,88,95] },
  { id: 'whatsapp', label: "Bugünkü WhatsApp Tıklaması", value: 347, change: 22.1, icon: 'ri-whatsapp-line', color: '#7CB342', trend: [20,30,25,40,35,50,45,60,55,65] },
  { id: 'form', label: "Bugünkü Form Gönderimi", value: 89, change: -3.5, icon: 'ri-file-list-3-line', color: '#64B5F6', trend: [50,45,55,40,60,50,65,55,70,60] },
  { id: 'conversion', label: "Dönüşüm Oranı", value: 6.9, change: 1.2, icon: 'ri-percent-line', color: '#D4AF37', isPercent: true, trend: [3,4,4,5,5,6,6,7,7,7] },
  { id: 'campaigns', label: "Aktif Kampanya Sayısı", value: 24, change: 4, icon: 'ri-megaphone-line', color: '#E8C87C', trend: [15,17,18,19,20,21,22,22,23,24] },
];

export const dailyVisitorData = [
  { date: '10 Mar', visitors: 820, unique: 640 },
  { date: '11 Mar', visitors: 1040, unique: 810 },
  { date: '12 Mar', visitors: 950, unique: 720 },
  { date: '13 Mar', visitors: 1200, unique: 930 },
  { date: '14 Mar', visitors: 1380, unique: 1050 },
  { date: '15 Mar', visitors: 1100, unique: 870 },
  { date: '16 Mar', visitors: 1290, unique: 990 },
  { date: '17 Mar', visitors: 1284, unique: 960 },
];

export const hourlyTrafficData = [
  { hour: '06', visits: 45 }, { hour: '07', visits: 82 }, { hour: '08', visits: 134 },
  { hour: '09', visits: 178 }, { hour: '10', visits: 220 }, { hour: '11', visits: 265 },
  { hour: '12', visits: 190 }, { hour: '13', visits: 210 }, { hour: '14', visits: 280 },
  { hour: '15', visits: 310 }, { hour: '16', visits: 295 }, { hour: '17', visits: 340 },
  { hour: '18', visits: 380 }, { hour: '19', visits: 420 }, { hour: '20', visits: 360 },
  { hour: '21', visits: 290 }, { hour: '22', visits: 210 }, { hour: '23', visits: 140 },
];

export const campaignPerformanceData = [
  { name: 'Botoks Kampanyası', value: 32, color: '#D4AF37' },
  { name: 'Lazer Epilasyon', value: 24, color: '#F4C2C2' },
  { name: 'Cilt Bakımı', value: 18, color: '#E8C87C' },
  { name: 'Saç Bakımı', value: 14, color: '#FFD0DB' },
  { name: 'Diğer', value: 12, color: '#C8C8C8' },
];

export const sourceConversionData = [
  { source: 'Google Ads', rate: 8.4, visitors: 3200 },
  { source: 'Instagram', rate: 6.2, visitors: 2800 },
  { source: 'Facebook', rate: 5.1, visitors: 1900 },
  { source: 'Organik', rate: 4.3, visitors: 1400 },
  { source: 'TikTok', rate: 3.8, visitors: 890 },
];

export const deviceData = [
  { name: 'Mobil', value: 68, color: '#D4AF37' },
  { name: 'Masaüstü', value: 24, color: '#F4C2C2' },
  { name: 'Tablet', value: 8, color: '#E8C87C' },
];

export const topCampaigns = [
  { id: 1, title: 'Botoks & Dolgu Paketi', views: 4280, img: 'https://readdy.ai/api/search-image?query=botox%20beauty%20treatment%20salon%20premium%20elegant%20soft%20background%20luxury%20skincare&width=60&height=60&seq=tc1&orientation=squarish' },
  { id: 2, title: 'Lazer Epilasyon 6 Seans', views: 3640, img: 'https://readdy.ai/api/search-image?query=laser%20hair%20removal%20beauty%20salon%20modern%20clean%20premium&width=60&height=60&seq=tc2&orientation=squarish' },
  { id: 3, title: 'İpek Kirpik Uygulaması', views: 2910, img: 'https://readdy.ai/api/search-image?query=eyelash%20extension%20beauty%20salon%20glamour%20close%20up&width=60&height=60&seq=tc3&orientation=squarish' },
  { id: 4, title: 'Dermapen Cilt Yenileme', views: 2450, img: 'https://readdy.ai/api/search-image?query=skin%20rejuvenation%20facial%20treatment%20beauty%20clinic%20premium&width=60&height=60&seq=tc4&orientation=squarish' },
  { id: 5, title: 'Saç Mezoterapisi', views: 1870, img: 'https://readdy.ai/api/search-image?query=hair%20mesotherapy%20scalp%20treatment%20beauty%20salon%20soft&width=60&height=60&seq=tc5&orientation=squarish' },
];

export const topButtons = [
  { name: 'WhatsApp Tıkla', clicks: 1840, max: 2000 },
  { name: 'Formu Doldur', clicks: 1290, max: 2000 },
  { name: 'Hemen Ara', clicks: 876, max: 2000 },
  { name: 'Detay Gör', clicks: 654, max: 2000 },
  { name: 'Randevu Al', clicks: 432, max: 2000 },
];

export const recentLeads = [
  { id: 1, name: 'Ayşe Kaya', source: 'Google Ads', campaign: 'Botoks Paketi', time: '8 dk önce', avatar: 'https://readdy.ai/api/search-image?query=turkish%20woman%20professional%20portrait%20beauty%20soft%20background&width=40&height=40&seq=l1&orientation=squarish' },
  { id: 2, name: 'Fatma Demir', source: 'Instagram', campaign: 'Lazer Epilasyon', time: '22 dk önce', avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20portrait%20professional%20smiling%20soft%20light&width=40&height=40&seq=l2&orientation=squarish' },
  { id: 3, name: 'Elif Yılmaz', source: 'Facebook', campaign: 'Cilt Bakımı', time: '45 dk önce', avatar: 'https://readdy.ai/api/search-image?query=woman%20headshot%20professional%20clean%20background%20warm&width=40&height=40&seq=l3&orientation=squarish' },
  { id: 4, name: 'Merve Şahin', source: 'Organik', campaign: 'Kirpik Uygulaması', time: '1 sa önce', avatar: 'https://readdy.ai/api/search-image?query=female%20portrait%20natural%20light%20professional%20beauty&width=40&height=40&seq=l4&orientation=squarish' },
];

export const recentEvents = [
  { id: 1, type: 'form_submit', label: 'Form Gönderimi', desc: 'Botoks & Dolgu Paketi', time: '3 dk önce', color: '#7CB342' },
  { id: 2, type: 'whatsapp_click', label: 'WhatsApp Tıklaması', desc: 'Lazer Epilasyon 6 Seans', time: '7 dk önce', color: '#25D366' },
  { id: 3, type: 'page_view', label: 'Sayfa Görüntüleme', desc: 'Cilt Bakımı Kampanyası', time: '12 dk önce', color: '#64B5F6' },
  { id: 4, type: 'button_click', label: 'Buton Tıklaması', desc: 'Hemen Ara - Dermapen', time: '18 dk önce', color: '#D4AF37' },
  { id: 5, type: 'form_start', label: 'Form Başlatma', desc: 'Saç Mezoterapisi', time: '25 dk önce', color: '#FFB74D' },
];

export const topSources = [
  { source: 'Google Ads', visitors: 3240, conversion: 8.4, icon: 'ri-google-line' },
  { source: 'Instagram', visitors: 2810, conversion: 6.2, icon: 'ri-instagram-line' },
  { source: 'Facebook', visitors: 1920, conversion: 5.1, icon: 'ri-facebook-circle-line' },
  { source: 'Organik', visitors: 1430, conversion: 4.3, icon: 'ri-search-line' },
];
